// extracted by mini-css-extract-plugin
module.exports = {"container":"_105329b597--container--Jnplz","description":"_105329b597--description--HOL_I","action":"_105329b597--action--rpMa7"};